export class NewFeedback {
  public feedback = "";
  public subject = "";
}
